import { adminNav } from '@ukam/admin/admin.nav';
import { complianceNav } from '@ukam/compliance/compliance.nav';
import { createAppConfig } from '@ukam/shell/bootstrap/create-app-config';
import { createAppRoutes } from '@ukam/shell/bootstrap/create-app-routes';
import { appSettings } from './app-settings';
import { featureRoutes } from './app.routes';
import { environment } from './environments/environment';
import { laasNav } from './laas.nav';

export const appConfig = createAppConfig({
  apiBaseUrl: environment.apiBaseUrl,
  appKey: 'laas',
  routes: createAppRoutes(featureRoutes, 'loans/dashboard'),
  navItems: [...laasNav, ...complianceNav, ...adminNav],
  appSettings,
});
